var EventSourceManager = (function () {
  var connections = {};
  var connectionStates = {};
  var globalRetryCounters = {};

  function createConnection(channel, options) {
    options = options || {};
    var baseUrl = options.baseUrl || '';
    var onMessage = options.onMessage || function () {};
    var onError = options.onError || function () {};
    var onOpen = options.onOpen || function () {};

    var state = {
      eventSource: null,
      reconnectTimer: null,
      reconnectDelay: 30000,
      maxReconnectDelay: 300000,
      reconnectAttempts: 0,
      maxReconnectAttempts: 5,
      channel: channel,
      isClosing: false,
    };

    function connect() {
      if (state.isClosing) {
        if (window.NETWRCK_DEBUG)
          console.debug(
            '[ESM] Skipping connect - connection is closing for channel:',
            channel
          );
        return;
      }

      if (
        state.eventSource &&
        state.eventSource.readyState !== EventSource.CLOSED
      ) {
        if (window.NETWRCK_DEBUG)
          console.debug(
            '[ESM] Skipping connect - connection already active for channel:',
            channel,
            'readyState:',
            state.eventSource.readyState
          );
        return;
      }

      if (connectionStates[channel] === 'connecting') {
        if (window.NETWRCK_DEBUG)
          console.debug(
            '[ESM] Skipping connect - already connecting to channel:',
            channel
          );
        return;
      }

      connectionStates[channel] = 'connecting';
      if (window.NETWRCK_DEBUG)
        console.debug('[ESM] Starting connection to channel:', channel);

      try {
        state.eventSource = new EventSource(
          baseUrl + '/api/live/subscribe?channel=' + encodeURIComponent(channel)
        );

        state.eventSource.onopen = function () {
          if (window.NETWRCK_DEBUG)
            console.debug('[ESM] Connected to channel:', channel);
          connectionStates[channel] = 'connected';
          state.reconnectDelay = 30000;
          state.reconnectAttempts = 0;

          globalRetryCounters[channel] = 0;
          onOpen();
        };

        state.eventSource.onmessage = function (e) {
          onMessage(e);
        };

        state.eventSource.onerror = function (err) {
          if (state.isClosing) {
            if (window.NETWRCK_DEBUG)
              console.debug(
                '[ESM] Ignoring error - connection is closing for channel:',
                channel
              );
            return;
          }

          connectionStates[channel] = 'error';
          if (window.NETWRCK_DEBUG)
            console.debug(
              '[ESM] Connection error for channel:',
              channel,
              '- attempt',
              state.reconnectAttempts + 1,
              'of',
              state.maxReconnectAttempts,
              '- will retry in',
              state.reconnectDelay,
              'ms'
            );

          if (state.eventSource) {
            state.eventSource.close();
            state.eventSource = null;
          }

          state.reconnectAttempts++;

          if (state.reconnectAttempts < state.maxReconnectAttempts) {
            state.reconnectTimer = setTimeout(function () {
              connectionStates[channel] = 'retrying';
              connect();
            }, state.reconnectDelay);

            state.reconnectDelay = Math.min(
              state.reconnectDelay * 2 + Math.random() * 1000,
              state.maxReconnectDelay
            );
          } else {
            console.error(
              '[ESM] Max reconnection attempts reached for channel:',
              channel
            );
            connectionStates[channel] = 'failed';
            onError(new Error('Max reconnection attempts reached'));
          }
        };
      } catch (err) {
        console.error(
          '[ESM] Failed to create EventSource for channel:',
          channel,
          err
        );
        connectionStates[channel] = 'error';
        onError(err);
      }
    }

    function close() {
      if (window.NETWRCK_DEBUG)
        console.debug('[ESM] Closing connection for channel:', channel);
      state.isClosing = true;
      connectionStates[channel] = 'closed';

      if (state.reconnectTimer) {
        clearTimeout(state.reconnectTimer);
        state.reconnectTimer = null;
      }

      if (state.eventSource) {
        state.eventSource.close();
        state.eventSource = null;
      }
    }

    connect();

    return {
      close: close,
      getState: function () {
        return {
          readyState: state.eventSource
            ? state.eventSource.readyState
            : EventSource.CLOSED,
          reconnectAttempts: state.reconnectAttempts,
          isClosing: state.isClosing,
        };
      },
    };
  }

  return {
    create: function (channel, options) {
      if (window.NETWRCK_DEBUG)
        console.debug('[ESM] Creating connection for channel:', channel);

      if (!globalRetryCounters[channel]) {
        globalRetryCounters[channel] = 0;
      }

      if (globalRetryCounters[channel] >= 5) {
        console.error(
          '[ESM] Global retry limit reached for channel:',
          channel,
          '- refusing to create new connection'
        );
        connectionStates[channel] = 'permanently_failed';
        return {
          close: function () {},
          getState: function () {
            return {
              readyState: EventSource.CLOSED,
              reconnectAttempts: globalRetryCounters[channel],
              isClosing: true,
            };
          },
        };
      }

      globalRetryCounters[channel]++;

      if (connections[channel]) {
        if (window.NETWRCK_DEBUG)
          console.debug(
            '[ESM] Closing existing connection for channel:',
            channel
          );
        connections[channel].close();
      }

      delete connectionStates[channel];

      connections[channel] = createConnection(channel, options);
      return connections[channel];
    },
    close: function (channel) {
      if (window.NETWRCK_DEBUG)
        console.debug(
          '[ESM] Closing and removing connection for channel:',
          channel
        );
      if (connections[channel]) {
        connections[channel].close();
        delete connections[channel];
      }
      delete connectionStates[channel];

      delete globalRetryCounters[channel];
    },
    closeAll: function () {
      if (window.NETWRCK_DEBUG) console.debug('[ESM] Closing all connections');
      for (var channel in connections) {
        if (Object.prototype.hasOwnProperty.call(connections, channel)) {
          connections[channel].close();
        }
      }
      connections = {};
      connectionStates = {};
      globalRetryCounters = {};
    },

    getConnectionState: function (channel) {
      return connectionStates[channel] || 'disconnected';
    },
  };
})();
